export default __webpack_public_path__ + "static/media/Hair_20_F_C5.72d8be29.svg";